import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "../i18n";
import Home from "../views/Home.vue";
import Search from "../views/Search.vue";
import SelectRoom from "../views/SelectRoom.vue";
import Payment from "../views/Payment.vue";
import Confirmation from "../views/Confirmation.vue";
import Information from "../views/Information.vue";
import store from "../store/index.js";

Vue.use(VueRouter);
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "title:Hotel Online Reservations",
      tklTitle: "tklTitle:Hotel Online Reservations",
      pvmTitle: "pvmTitle:Hotel Online Reservations",
      glTitle: "glTitle:Hotel Online Reservations"
    }
  },
  {
    path: "/booking-search",
    name: "Search",
    component: Search,
    meta: {
      title: "title:Booking Search",
      tklTitle: "tklTitle:Booking Search",
      pvmTitle: "pvmTitle:Booking Search",
      glTitle: "glTitle:Booking Search"
    }
  },
  {
    path: "/select-room",
    name: "SelectRoom",
    component: SelectRoom,
    meta: {
      title: "title:Select Room",
      tklTitle: "tklTitle:Select Room",
      pvmTitle: "pvmTitle:Select Room",
      glTitle: "glTitle:Select Room"
    }
  },
  {
    path: "/payment",
    name: "Payment",
    component: Payment,
    meta: {
      title: "title:Payment",
      tklTitle: "tklTitle:Payment",
      pvmTitle: "pvmTitle:Payment",
      glTitle: "glTitle:Payment"
    }
  },
  {
    path: "/confirmation",
    name: "Confirmation",
    component: Confirmation,
    meta: {
      title: "title:Confirmation",
      tklTitle: "tklTitle:Confirmation",
      pvmTitle: "pvmTitle:Confirmation",
      glTitle: "glTitle:Confirmation"
    }
  },
  {
    path: "/book-information",
    name: "Information",
    component: Information,
    meta: {
      title: "title:My Booking Information",
      tklTitle: "tklTitle:My Booking Information",
      pvmTitle: "pvmTitle:My Booking Information",
      glTitle: "glTitle:My Booking Information"
    }
  },
  {
    path: "/404",
    name: "page-error",
    component: () =>
      import(/* webpackChunkName: "demo" */ "../views/Error.vue"),
    meta: {
      title: "title:Page not found"
    }
  },
  {
    path: "/terms-of-use",
    name: "TermsOfUse",
    component: () =>
      import(/* webpackChunkName: "demo" */ "../views/TermsOfUse.vue"),
    meta: {
      title: "title:Terms of Use",
      tklTitle: "tklTitle:Terms of Use",
      pvmTitle: "pvmTitle:Terms of Use",
      glTitle: "glTitle:Terms of Use"
    }
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () =>
      import(/* webpackChunkName: "demo" */ "../views/PrivacyPolicy.vue"),
    meta: {
      title: "title:Privacy Policy",
      tklTitle: "tklTitle:Privacy Policy",
      pvmTitle: "pvmTitle:Privacy Policy",
      glTitle: "glTitle:Privacy Policy"
    }
  },
  {
    path: "/CustomerServices",
    name: "CustomerServices",
    component: () =>
      import(/* webpackChunkName: "demo" */ "../views/CustomerServices.vue"),
    meta: {
      title: "Customer Services"
    }
  },
  {
    name: "refresh",
    path: "/refresh",
    component: () => import("../views/Refresh.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/reservation",
  routes
});

router.beforeEach((to, from, next) => {
  const skinArr = ["tkl", "glp", "pvm", "gl"];
  const langArr = ["en", "cn", "tc", "jap", "ko"];
  const querySkin = skinArr.find(x => x === to.query.skin);
  const localSkin = skinArr.find(x => x === localStorage.skinCode);
  const queryLang = langArr.find(x => x === to.query.lang);
  const localLang = langArr.find(x => x === localStorage.lang);

  if (querySkin) {
    to.query.skin = querySkin;
    localStorage.skinCode = querySkin;
  } else if (localSkin) {
    to.query.skin = localSkin;
  } else {
    to.query.skin = "gl";
    localStorage.skinCode = "gl";
  }

  if (queryLang) {
    to.query.lang = queryLang;
    localStorage.lang = queryLang;
    i18n.locale = queryLang;
  } else if (localLang) {
    to.query.lang = localLang;
    i18n.locale = queryLang;
  } else {
    to.query.lang = "en";
    localStorage.lang = "en";
    i18n.locale = "en";
  }

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    store.commit("stateChange", {
      k: "gaData",
      v: Object.assign({}, store.gaData, {
        skinCode: localStorage.getItem("skinCode")
      })
    });

    if (store.state.gaData.skinCode === "tkl") {
      document.title = i18n.t(to.meta.tklTitle);
      document.querySelector(
        '[rel="icon"]'
      ).href = `${process.env.BASE_URL}tklfavicon.ico`;
    } else if (store.state.gaData.skinCode === "pvm") {
      document.title = i18n.t(to.meta.pvmTitle);
      document.querySelector(
        '[rel="icon"]'
      ).href = `${process.env.BASE_URL}pvmfavicon.ico`;
    } else if (store.state.gaData.skinCode === "glp") {
      document.querySelector(
        '[rel="icon"]'
      ).href = `${process.env.BASE_URL}glpfavicon.ico`;
      document.title = i18n.t(to.meta.title);
    } else {
      document.title = i18n.t(to.meta.glTitle);
      document.querySelector(
        '[rel="icon"]'
      ).href = `${process.env.BASE_URL}glfavicon.ico`;
    }
  }

  if (to.matched.length === 0) {
    from.name
      ? next({
          name: from.name
        })
      : next({ name: "page-error" });
  } else {
    if (!queryLang || (!querySkin && to.name !== "refresh")) {
      next({
        path: to.path,
        query: {
          ...to.query
        }
      });
    }
    next(); //如果匹配到正确跳转
  }
});

export default router;
